import React, { FC, ReactNode, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { IState } from '../../reducers';
import { getDisabledPlatformFeatureRedirect, selectPlatformRouteFlags } from '../../tools/platformConfigurationUi';

interface IProps {
    children: ReactNode;
}

export const PlatformDisabledFeatureRedirect: FC<IProps> = ({ children }) => {
    const { pathname, search } = useLocation();
    const navigate = useNavigate();
    const { isLoggedIn, isShadowAuth, hasPlatformConfiguration, platformConfigurationStatus, routeFlags } = useSelector((state: IState) => ({
        isLoggedIn: state.context.isLoggedIn,
        isShadowAuth: state.context.isShadowAuth,
        hasPlatformConfiguration: !!state.config.platformConfiguration,
        platformConfigurationStatus: state.config.platformConfigurationStatus,
        routeFlags: selectPlatformRouteFlags(state)
    }));

    const configReady = platformConfigurationStatus === 'loaded' || hasPlatformConfiguration;
    const redirectTo = (!isShadowAuth && configReady)
        ? getDisabledPlatformFeatureRedirect(`${pathname}${search}`, routeFlags, { isLoggedIn })
        : null;
    const shouldRedirect = !!redirectTo && redirectTo !== pathname;

    useEffect(() => {
        if (shouldRedirect && redirectTo) {
            navigate(redirectTo, { replace: true });
        }
    }, [navigate, redirectTo, shouldRedirect]);

    if (shouldRedirect && redirectTo) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
};
